import {
    addMonths,
    compareAsc,
    compareDesc,
    differenceInDays,
    format,
    startOfYear,
    subHours,
} from 'date-fns';
import { breadcrumb } from './logging';

export const getWeighInFromStartAt = (startAt: Date | string | number): string => {
    return subHours(new Date(startAt), 2).toLocaleString();
};

export function readableDateFromDate(date: Date | number | string): string {
    return format(date, 'LL/dd/yyyy');
}

export function readableTimeFromDate(date: Date | number | string): string {
    return format(date, 'h:mm aaa');
}

export function readableDateTimeFromDate(date: Date | number | string | null): string {
    return date ? format(date, 'EEEE, L/d h:mm aaa') : '';
}

// Ported from legacy codebase
export const calculateAge = (birthday: string) => {
    if (!birthday) {
        breadcrumb('calculateAge invalid birthday', { birthday });
        return 0;
    }
    const today = new Date();
    const birthDate = new Date(birthday);
    let age_now = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age_now--;
    }
    return age_now;
};

// Ported from legacy codebase
export const hasDatePassed = (dateString: string | null) => {
    if (!dateString) {
        return true;
    }
    const givenDate = new Date(dateString).getTime();
    const currentDate = Date.now();

    return givenDate < currentDate;
};

export const sortByDate = (
    date1: Date | string | number,
    date2: Date | string | number,
    direction: 'asc' | 'desc' = 'asc',
) => {
    return direction === 'asc' ? compareAsc(date1, date2) : compareDesc(date1, date2);
};

// value should be a string in this format: '2013-01-01T00:00:00+00:00'
// NOT the same as toISOString
export const formatAsISOJan1st = (date: Date | string): string => {
    return `${format(startOfYear(new Date(date)), "yyyy-MM-dd'T'HH:mm:ss", {})}+00:00`;
};

export const calculateYearsExperience = (activeSince: string | undefined | null) => {
    if (!activeSince) {
        return 0;
    }
    const today = new Date();
    let activeDate = new Date(activeSince);

    if (
        // if active date is Jan 1st or Dec 31st, then we need to add 7 months for season change accuracy
        (activeDate.getMonth() === 0 && activeDate.getDate() === 1) ||
        (activeDate.getMonth() === 11 && activeDate.getDate() === 31) // will be dec 31st if timezone is differs
    ) {
        activeDate = addMonths(activeDate, 7);
    }

    const diff = differenceInDays(today, activeDate);
    const experienceNow = Math.floor(diff / 365);

    return Math.max(experienceNow, 0);
};
